import * as yup from "yup";

export const podCastSchema = yup.object().shape({
  podcastName: yup.string(),
  podcastType: yup.string(),
  podcastLanguage: yup.string(),
  podcastseriesName: yup.string(),
  guestName: yup.string().required("Guest Name Is Required"),
  guestCity: yup.string(),
  podcastDate: yup.string(),
  podcastVenue: yup.string(),
  cameraName: yup.string(),
  podcastvideoName: yup.string(),
  podcastDescription: yup.string(),
  podcastQuestions: yup.string(),
  podcastCredits: yup.string(),
  podcastEditor: yup.string(),
  podCastComingSoonPoster: yup.string(),
  podCastComingSoonDescription: yup.string(),
  podCastFinalFootage: yup.string(),
  markAsPublished: yup.string(),
  ispodcastComplated: yup.boolean(),
  rowImageGuest: yup.string(),
  podcastBrand: yup.string(),
  guestPrvRef: yup.string(),
  rawFolderPath: yup.string(),
  shootingDate: yup.string(),
  podcastFirstDraft: yup.string(),
  podCastPublishDescription: yup.string(),
  podCastPublishTitle: yup.string(),
  taskdedline: yup.string(),
});
